import { kitById, leagueOf } from '@penalty-cup/shared';
import { useState } from 'react';
import { Jersey } from '../components/Jersey.js';
import { PendingInvite } from '../components/PendingInvite.js';
import { useApp } from '../store.js';

export function Home() {
  const me = useApp((s) => s.me);
  const play = useApp((s) => s.play);
  const joining = useApp((s) => s.joining);
  const setView = useApp((s) => s.setView);
  const notice = useApp((s) => s.notice);
  const soundOn = useApp((s) => s.soundOn);
  const toggleSound = useApp((s) => s.toggleSound);
  const createDuel = useApp((s) => s.createDuel);
  const createFriendsCup = useApp((s) => s.createFriendsCup);
  const [cupSize, setCupSize] = useState(false);
  // Фото не загрузилось (нет сети, удалено) — показываем инициалы на цвете формы
  const [photoFailed, setPhotoFailed] = useState(false);
  if (!me) return null;
  // Инициалы — первые буквы двух первых слов («Северное Сияние» → «СС»), у одного слова — две буквы
  const words = (me.teamName ?? me.firstName).split(' ').filter(Boolean);
  const initials = (
    words.length > 1 ? words[0]![0]! + words[1]![0]! : (words[0] ?? '?').slice(0, 2)
  ).toUpperCase();
  const league = leagueOf(me.rating);
  return (
    <main className="screen home">
      <button
        type="button"
        className="sound-toggle"
        onClick={toggleSound}
        aria-label={soundOn ? 'Выключить звук' : 'Включить звук'}
        aria-pressed={soundOn}
      >
        {soundOn ? '🔊' : '🔇'}
      </button>
      <div className="home__profile">
        <span className="avatar-wrap">
          {me.photoUrl && !photoFailed ? (
            <img className="avatar" src={me.photoUrl} alt="" onError={() => setPhotoFailed(true)} />
          ) : (
            <span
              className="avatar"
              style={{ background: kitById(me.kit).color, color: kitById(me.kit).accent }}
            >
              {initials}
            </span>
          )}
          <Jersey kit={me.kit} className="avatar-wrap__kit" />
        </span>
        <div>
          <div className="home__name">{me.teamName ?? me.firstName}</div>
          <div className="home__league" style={{ color: league.league.color }}>
            Лига {league.league.name} · {me.rating}
            {me.stats.currentWinStreak >= 2 && (
              <span className="home__streak"> · 🔥 {me.stats.currentWinStreak}</span>
            )}
          </div>
        </div>
      </div>
      <div className="league-bar" aria-label="Прогресс лиги">
        <span
          className="league-bar__fill"
          style={{ width: `${league.progress * 100}%`, background: league.league.color }}
        />
        <span className="league-bar__text">
          {league.next ? `До лиги ${league.next.name} — ${league.toNext}` : 'Высшая лига'}
        </span>
      </div>
      <div className="home__stats">
        <div className="stat">
          <b>{me.stats.tournamentsWon}</b>
          <span>кубков</span>
        </div>
        <div className="stat">
          <b>{me.stats.matchesWon}</b>
          <span>побед</span>
        </div>
        <div className="stat">
          <b>🪙 {me.coins}</b>
          <span>монет</span>
        </div>
      </div>
      <div className="home__hero" aria-hidden="true">
        🏆
      </div>
      <h1 className="home__title">Penalty Cup</h1>
      <p className="home__lead">Турнир на 8: три победы в сериях пенальти — и кубок твой.</p>
      {notice && (
        <p className="field__hint field__hint--error" role="alert">
          {notice}
        </p>
      )}
      <div className="home__friends">
        <button type="button" className="chip" onClick={() => void createDuel()} disabled={joining}>
          ⚔️ Вызвать друга
        </button>
        {cupSize ? (
          <>
            <button
              type="button"
              className="chip"
              onClick={() => void createFriendsCup(4)}
              disabled={joining}
            >
              👥 На 4
            </button>
            <button
              type="button"
              className="chip"
              onClick={() => void createFriendsCup(8)}
              disabled={joining}
            >
              👥 На 8
            </button>
          </>
        ) : (
          <button type="button" className="chip" onClick={() => setCupSize(true)} disabled={joining}>
            👥 Кубок с друзьями
          </button>
        )}
      </div>
      <button type="button" className="link home__lb" onClick={() => setView('shop')}>
        🛍 Магазин
      </button>
      <button type="button" className="link home__lb" onClick={() => setView('leaderboard')}>
        🏅 Лидерборд
      </button>
      <PendingInvite />
      <button type="button" className="play" onClick={() => void play()} disabled={joining}>
        {joining ? 'Ищем турнир…' : 'PLAY'}
      </button>
    </main>
  );
}
